import baseTheme from "@/themes/baseTheme";
import { ThemeConfig } from "antd";

const devTheme: ThemeConfig = {
  ...baseTheme,
  token: {
    ...baseTheme.token,
    colorBgLayout: "#C1E1C1",
  },
};

export default devTheme;
